<h3>License Details</h3>
<div class="table-responsive">
  <table class="table table-striped table-hover" *ngIf="contractDetails.product == 'FSBLOCKER'">
    <thead>
      <tr>
        <th>Type</th>
        <th>Capacity Purchased</th>
        <th>Capacity Available</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th>Capacity (TB)</th>
        <td>{{ contractDetails.capacity?.total || contractDetails.totalCapacityTB }}</td>
        <td>{{ contractDetails.capacity?.available }}</td>
      </tr>
    </tbody>
  </table>

  <table class="table table-striped table-hover" *ngIf="contractDetails.siteEnabled">
    <thead>
      <tr>
        <th>Type</th>
        <th>Licences Available</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th>Site Licences</th>
        <td>{{ contractDetails.siteLicences }}</td>
      </tr>
    </tbody>
  </table>

  <table class="table table-striped table-hover" *ngIf="contractDetails.product != 'SYSBACK' && contractDetails.product != 'FSBLOCKER' && !contractDetails.siteEnabled">
    <thead>
      <tr>
        <th>Type</th>
        <th>Licenses Purchased</th>
        <th>Activations Allowed</th>
        <th>Activations Available</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th>Physical Server</th>
        <td>{{ contractDetails.serverLics }}</td>
        <td>{{ contractDetails.activations?.total }}</td>
        <td>{{ contractDetails.activations?.available }}</td>
      </tr>
      <tr>
        <th>Virtual Server Packs</th>
        <td>{{ contractDetails.virtualPacks }}</td>
        <td>{{ contractDetails.vmActivations?.total }}</td>
        <td>{{ contractDetails.vmActivations?.available }}</td>
      </tr>
      <tr>
        <th>Desktop</th>
        <td>{{ contractDetails.desktopLics }}</td>
        <td>{{ contractDetails.desktopActivations?.total }}</td>
        <td>{{ contractDetails.desktopActivations?.available }}</td>
      </tr>
    </tbody>
  </table>

  <table class="table table-striped table-hover" *ngIf="contractDetails.product == 'SYSBACK'">
    <thead>
      <tr>
        <th>Licenses Purchased</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{{ contractDetails.activations?.total }}</td>
      </tr>
    </tbody>
  </table>
</div>
